module.exports = __webpack_public_path__ + "static/media/1244_elements_roles.c376f8a0.png";